import {
  Component,
  OnInit,
  Input,
  OnDestroy,
} from "@angular/core";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ConfirmationModelComponent } from "src/app/shared/components/confirmation-model/confirmation-model.component";
import { ResourceEmailComponent } from "src/app/shared/components/resource-email/resource-email.component";
import { PlaybookCommunicationService } from "../../shared/services/playbook-communication.service";
import { CommonHttpService } from "../../../shared/services/common-http/common-http.service";
import { SessionStorageService } from "src/app/shared/services/session-storage/session-storage.service";
import {
  serverUrl,
  Modalconfig,
  DefaultLanguageId,
} from "src/app/shared/constants";
import {
  Resource,
  Container,
  ResourceFolders,
} from "src/app/shared/model/container.models";
import { CommunicationService } from "src/app/shared/services/communication/communication.service";
import { AddEditResourceComponent } from "./add-edit-resource/add-edit-resource.component";
import { sessionProfile } from "src/app/shared/interfaces/sessionStorageModel";
import { CdkDragDrop, moveItemInArray } from "@angular/cdk/drag-drop";
import { Subscription } from "rxjs";
import {
  forEach,
  cloneDeep,
  each,
  sortBy,
  findIndex,
  filter,
  some,
} from "lodash";
import { UntypedFormControl, Validators } from "@angular/forms";
import { FolderDownloadService } from "src/app/shared/services/folder-download/folder-download.service";
import { MessageService } from "src/app/shared/services/message/message.service";
import { IResourceFull } from "projects/playbook-viewer/src/app/playbook-viewer/search-playbook/search-playbook.component";
@Component({
    selector: "app-resource-lists",
    templateUrl: "./resource-lists.component.html",
    styleUrls: ["./resource-lists.component.scss"],
    standalone: false
})
export class ResourceListsComponent
  implements OnInit, OnDestroy
{
  @Input("resContainer") container: Container;
  @Input("languageId") languageId;
  @Input() companyId;
  @Input("pageTemplateId") pageTemplateId = null;
  @Input() pageFrom = null;
  serverUrl = serverUrl;
  defaultLanguageId = DefaultLanguageId;
  private resourceModal: BsModalRef;
  private resModalSubscription: Subscription;
  private confirmationModalRef: BsModalRef;
  private resEmailModalRef: BsModalRef;
  private loggedInProfile: sessionProfile;
  private confModalSubscription: Subscription;
  private folderModalRef: BsModalRef;
  private deleteModalRef: BsModalRef;
  folderTitle = new UntypedFormControl("", [
    Validators.required,
    Validators.maxLength(100),
  ]);
  editFolder = null;
  selectedFolder = null;
  constructor(
    private messageService: MessageService,
    private commService: PlaybookCommunicationService,
    private communicationService: CommunicationService,
    private commonHttpService: CommonHttpService,
    private sessionStorageService: SessionStorageService,
    private modalService: BsModalService,
    private folderDownloadService: FolderDownloadService
  ) {}

  ngOnInit() {
    this.loggedInProfile =
      this.sessionStorageService.getLoggedInProfileDetail();
    this.setChangedResources();
  }

  /**
   * To handle added or updated resources
   */
  setChangedResources() {
    this.resModalSubscription = this.modalService.onHide.subscribe(() => {
      if (this.resourceModal) {
        const originalResource = this.resourceModal.content.originalResource;
        const addedResource = this.resourceModal.content.addedResource;
        const updatedResource = this.resourceModal.content.updatedResource;
        if (addedResource) {
          if (addedResource.folderId) {
            const selectedFolder = this.container.resourceFolders.find(
              (folder) => folder.id === addedResource.folderId
            );
            selectedFolder.resources.push(addedResource);
          } else {
            // First we need to re-order all the resource so new resource can placed at the top.
            each(this.container.resources, (resource: Resource) => {
              resource.orderBy = resource.orderBy + 1;
            });
            // adding a new resource
            this.container.resources.unshift(addedResource);
          }
        } else if (updatedResource) {
          if (
            updatedResource.folderId !== originalResource.folderId &&
            originalResource.folderId != null
          ) {
            const selectedFolder = this.container.resourceFolders.find(
              (folder) => folder.id === originalResource.folderId
            );
            selectedFolder.resources = selectedFolder.resources.filter(
              (res) => res.id !== updatedResource.id
            );
          } else if (
            updatedResource.folderId !== originalResource.folderId &&
            originalResource.folderId == null
          ) {
            this.container.resources = this.container.resources.filter(
              (res) => res.id !== updatedResource.id
            );
          }
          if (
            updatedResource.folderId === originalResource.folderId &&
            originalResource.folderId
          ) {
            const selectedFolder = this.container.resourceFolders.find(
              (folder) => folder.id === updatedResource.folderId
            );
            const resourceIndex = findIndex(
              selectedFolder.resources,
              (eachResouces) => eachResouces.id === updatedResource.id
            );
            if (resourceIndex !== -1) {
              selectedFolder.resources[resourceIndex] = updatedResource;
            } else {
              selectedFolder.resources.push(updatedResource);
            }
          } else if (updatedResource.folderId) {
            const selectedFolder = this.container.resourceFolders.find(
              (folder) => folder.id == updatedResource.folderId
            );
            selectedFolder.resources.push(updatedResource);
          } else {
            const resoursIndex = findIndex(
              this.container.resources,
              (eachResouces) => eachResouces.id === updatedResource.id
            );
            if (resoursIndex !== -1) {
              this.container.resources[resoursIndex] = updatedResource;
            } else {
              this.container.resources.push(updatedResource);
            }
          }
        }
        this.resourceModal = null;
      }
    });
  }

  /**
   * To handle drop event for reordering of resources
   */
  drop(event: CdkDragDrop<string[]>, resourceType, folderId?: number) {
    switch (resourceType) {
      case 1:
        // folders
        this.reOrderResource(event, this.container.resourceFolders, true);
        break;
      case 2:
        // folders
        const folderIndex = findIndex(
          this.container.resourceFolders,
          (eachFolders) => eachFolders.id === folderId
        );
        if (folderIndex !== -1) {
          this.reOrderResource(
            event,
            this.container.resourceFolders[folderIndex].resources
          );
        }
        break;
      case 3:
        // outermost resources
        this.reOrderResource(event, this.container.resources);
        break;
    }
  }

  reOrderResource(
    event: CdkDragDrop<string[]>,
    reOrderData,
    isResourceFolder = false
  ) {
    reOrderData = sortBy(reOrderData, (o) => o.orderBy);
    const oldOrderResources = cloneDeep(reOrderData);
    moveItemInArray(reOrderData, event.previousIndex, event.currentIndex);
    let order = 0;
    const newOrders = [];
    forEach(reOrderData, (res) => {
      newOrders.push({ id: res.id, order });
      order++;
    });

    // To change resources orders
    forEach(reOrderData, (res) => {
      forEach(newOrders, (obj) => {
        if (res.id === obj.id) {
          res.orderBy = obj.order;
        }
      });
    });

    this.commonHttpService
      .put({
        uri: "/api/Resources/ReorderResources",
        object: {
          profileId: this.loggedInProfile.id,
          playbookId: this.container.playbookId,
          orders: newOrders,
          isResourceFolder,
          pageTemplateId: +this.pageTemplateId,
        },
      })
      .subscribe(
        (response) => {},
        (error) => {
          reOrderData = cloneDeep(oldOrderResources);
        }
      );
  }

  /**
   * To toggle resource drawer
   */
  toggleDrawer() {
    this.commService.ToggleResourcesOn();
  }

  /**
   * @param resource resource object
   * To check if resource object contain resource link or not
   */
  checkResourceForNullAssets(
    resource: Resource & ResourceFolders,
    isCheckUrl = false,
    isPrimaryLang = true
  ) {
    if (!resource) {
      return false;
    }

    if (isPrimaryLang) {
      if (
        (resource.type === 1 &&
          resource.linkUrl &&
          resource.linkUrl.toString().trim() !== "") ||
        ((resource.type === 2 || resource.type === 0) && resource.assetId)
      ) {
        return true;
      } else if (resource.resources && resource.resources.length) {
        return isCheckUrl
          ? some(
              resource.resources,
              (eachResources) =>
                (eachResources.type === 2 || eachResources.type === 0) &&
                eachResources.assetId
            )
          : true;
      }
    } else {
      return true;
    }
  }

  /**
   * To check asset condition in resources
   * Used in language resources to show conditional fields and also in original resources
   * @param resource resource object
   */
  checkResourceAssetCondition(resource: Resource) {
    let flag = false;
    if (resource) {
      if (this.languageId == this.defaultLanguageId) {
        // For Links
        if (
          resource.type === 1 &&
          resource.linkUrl !== undefined &&
          resource.linkUrl !== null &&
          resource.linkUrl.toString().trim() !== ""
        ) {
          flag = true;
        } else if (
          (resource.type === 2 || resource.type === 0) &&
          resource.asset !== undefined &&
          resource.asset !== null
        ) {
          flag = true;
        }
      } else {
        // for secondary languages resources
        flag = true;
      }
    }
    return flag;
  }

  /**
   * To open resource ratings modal
   * @param id resource id
   */
  openRatingsModal(id, type = 1) {
    this.communicationService.setResourceRatingsStatus({
      status: true,
      resourceId: id,
      type,
    });
  }

  /**
   * To open link of url resource type
   */
  openResourceUrl(resource: Resource) {
    window.open(resource.linkUrl, "_blank");
    this.maintainClick(resource, true);
  }

  /**
   * To open the resource on new page for download
   */
  openResource(resource: Resource) {
    return `${window.location.origin}/assets/download/${resource.assetId}${
      this.pageFrom ? "?pageFrom=" + this.pageFrom : ""
    }`;
  }

  /**
   * To maintain download resource Clicks
   */
  maintainClick(resource: Resource, isUrl = false) {
    this.commonHttpService
      .put({
        uri: `/api/Resources/MaintainClick`,
        object: {
          resourceId: resource.id,
          type: isUrl ? 1 : 0,
          pageId: this.container.id,
          profileId: this.loggedInProfile.id,
          playbookId: this.container.playbookId,
          pageTemplateId: this.pageTemplateId,
        },
      })
      .subscribe();
  }

  /**
   * To open resource modal for add or update
   * @param resource resource in case of update
   */
  openResourceModal(resource) {
    const selectedFolder =
      resource && resource.folderId
        ? {
            id: resource.folderId,
            label: this.container.resourceFolders.find(
              (folder) => folder.id === resource.folderId
            ).name,
          }
        : { id: null, label: "None" };
    const initialState = {
      resourceData: cloneDeep(resource),
      containerId: this.container.id,
      playbookId: this.container.playbookId,
      profileId: this.loggedInProfile.id,
      resourceCount: this.container.resources
        ? this.container.resources.length
        : 0,
      isUpdate: resource ? true : false,
      resourcefolders: this.container.resourceFolders
        ? this.container.resourceFolders
        : [],
      selectedFolder,
      pageTemplateId: this.pageTemplateId,
      pageFrom: this.pageFrom,
    };
    this.resourceModal = this.modalService.show(
      AddEditResourceComponent,
      Object.assign(
        { initialState },
        { class: "custom-modal overflow-y-unset" },
        Modalconfig
      )
    );
  }

  /**
   * To delete a resource
   * @param resource resource to be deleted
   */
  deleteResource(resource, folderId) {
    const initialState = {
      msg: `Are you sure you want to delete the resource '${resource.title}'?`,
    };
    this.confirmationModalRef = this.modalService.show(
      ConfirmationModelComponent,
      Object.assign(
        { initialState },
        { class: "custom-modal confirm-modal" },
        Modalconfig
      )
    );
    this.confModalSubscription =
      this.confirmationModalRef.content.onclose.subscribe(
        (isDelete: boolean) => {
          if (isDelete) {
            this.commonHttpService
              .deleteWithBody({
                uri: "/api/Resources/DeleteResource",
                object: {
                  id: resource.id,
                  profileId: this.loggedInProfile.id,
                  playbookId: this.container.playbookId,
                  pageTemplateId: this.pageTemplateId,
                  languageId: this.languageId,
                },
              })
              .subscribe((response: any) => {
                // filtering out deleted resource
                //
                let folderIndex;
                if (folderId) {
                  folderIndex = this.container.resourceFolders.findIndex(
                    (folder) => folder.id === folderId
                  );
                }
                if (folderIndex > -1) {
                  if (this.languageId === 1) {
                    this.container.resourceFolders[folderIndex].resources =
                      this.container.resourceFolders[
                        folderIndex
                      ].resources.filter((res) => res.id !== resource.id);
                  } else {
                    const resInQuestion = this.container.resourceFolders[
                      folderIndex
                    ].resources.find((r) => r.id === resource.id);
                    resInQuestion.asset = null;
                    resInQuestion.assetId = null;
                    resInQuestion.url = "";
                    resInQuestion.linkUrl = "";
                  }
                } else {
                  if (this.languageId === 1) {
                    this.container.resources = this.container.resources.filter(
                      (res) => res.id !== resource.id
                    );
                  } else {
                    const resInQuestion = this.container.resources.find(
                      (r) => r.id === resource.id
                    );
                    resInQuestion.asset = null;
                    resInQuestion.assetId = null;
                    resInQuestion.url = "";
                    resInQuestion.linkUrl = "";
                  }
                }
              });
          }
          this.confirmationModalRef.hide();
          this.confModalSubscription.unsubscribe();
        }
      );
  }

  /**
   * To open modal for email resource
   * @param selectedResource selected resource in case resource email icon clicked
   */
  openMailResourceModal(selectedResource: Resource, folderName?: string) {
    const langId = this.languageId || this.defaultLanguageId;
    this.commonHttpService
      .get({
        uri:
          "/api/Resources/GetPlaybooksAllResources?playbookId=" +
          this.container.playbookId +
          "&languageId=" +
          langId,
      })
      .subscribe((response: Array<Resource>) => {
        const resourceData = selectedResource
          ? filter(response, (eachResources) =>
              typeof selectedResource.type === "number"
                ? selectedResource.folderId === eachResources.folderId
                : selectedResource.id === eachResources.folderId
            )
          : response;
        const initialState = {
          resources: resourceData,
          selectedResource,
          sendMultiple: selectedResource && !folderName ? false : true,
          playbookId: this.container.playbookId,
          languageId: langId,
          folderName,
        };
        this.resEmailModalRef = this.modalService.show(
          ResourceEmailComponent,
          Object.assign(
            { initialState },
            { class: "custom-modal confirm-modal" },
            Modalconfig
          ) as any
        );
      });
  }

  openFolder(id) {
    if (this.selectedFolder == id) {
      this.selectedFolder = null;
      return;
    }
    this.selectedFolder = id;
  }

  openfolderModal(selectedFolder, template) {
    if (selectedFolder !== null) {
      this.folderTitle.setValue(selectedFolder.name);
    }
    this.editFolder = selectedFolder;
    this.folderModalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "custom-modal" }, Modalconfig)
    );
  }
  openDeleteFolderModal(selectedFolder, template) {
    this.editFolder = selectedFolder;
    this.deleteModalRef = this.modalService.show(
      template,
      Object.assign({}, { class: "custom-modal" }, Modalconfig)
    );
  }

  closeEditfolderModal() {
    this.folderModalRef.hide();
    this.folderTitle.reset("");
  }

  closeDeletefolderModal() {
    this.deleteModalRef.hide();
  }

  downloadFolder(folder) {
    this.folderDownloadService.getDownloadReportData(
      folder.id,
      this.container,
      this.languageId
    );
  }

  deleteResourcefolder(isAllResourceDelete) {
    this.commonHttpService
      .delete({
        uri: `/api/Resources/DeleteResourceFolder?id=${this.editFolder.id}&isAllResourceDelete=${isAllResourceDelete}&pageId=${this.container.id}&playbookId=${this.container.playbookId}`,
      })
      .subscribe(() => {
        const deleteFolderIndex = findIndex(
          this.container.resourceFolders,
          (eachFolders) => eachFolders.id === this.editFolder.id
        );
        if (deleteFolderIndex !== -1) {
          if (
            this.container.resourceFolders[deleteFolderIndex].resources
              .length &&
            !isAllResourceDelete
          ) {
            this.container.resources = sortBy(
              this.container.resources,
              (o) => o.orderBy
            );
            forEach(this.container.resources, (eachResources, index) => {
              eachResources.orderBy = index;
            });
            let resourcesLength = this.container.resources.length;
            forEach(
              this.container.resourceFolders[deleteFolderIndex].resources,
              (folderEachResources) => {
                folderEachResources.orderBy = resourcesLength++;
                folderEachResources.folderId = null;
                this.container.resources.push(folderEachResources);
              }
            );
          }
        }
        this.container.resourceFolders = this.container.resourceFolders.filter(
          (folder) => folder.id !== this.editFolder.id
        );
        this.editFolder = null;
        this.closeDeletefolderModal();
      });
  }

  saveFolderBlock() {
    if (this.editFolder !== null) {
      this.commonHttpService
        .put({
          uri: `/api/Resources/updateResourceFolder`,
          object: {
            id: this.editFolder.id,
            playbookId: this.container.playbookId,
            languageId: this.languageId,
            pageId: this.container.id,
            name: this.folderTitle.value.trim(),
            order: this.editFolder.order,
            PageTemplateId: +this.pageTemplateId,
          },
        })
        .subscribe((resp) => {
          this.container.resourceFolders.find(
            (folder) => folder.id === this.editFolder.id
          ).name = this.folderTitle.value.trim();
          this.folderTitle.reset("");
          this.folderModalRef.hide();
        });
    } else {
      this.commonHttpService
        .post({
          uri: `/api/Resources/AddResourceFolder`,
          object: {
            playbookId: this.container.playbookId,
            pageId: this.container.id,
            name: this.folderTitle.value.trim(),
            PageTemplateId: +this.pageTemplateId,
          },
        })
        .subscribe((resp: ResourceFolders) => {
          if (this.container.resourceFolders == null) {
            this.container.resourceFolders = [];
          }
          this.container.resourceFolders.push(resp);
          this.folderTitle.reset("");
          this.folderModalRef.hide();
        });
    }
  }

  ngOnDestroy() {
    if (this.resModalSubscription) {
      this.resModalSubscription.unsubscribe();
    }
  }

  copyResourceShareableLink(params: {
    resourceId?: number;
    companyId?: number;
    playbookId?: number;
    pageId?: number;
    folderId?: number;
    languageId?: number;
    pageTemplateId?: number;
    pageFrom?: number;
  }) {
    const url = new URL(
      `${window.location.protocol}${window.location.host}/home/resourcelanding`
    );

    if (params.resourceId) {
      url.searchParams.append("resourceId", `${params.resourceId}`);
    }
    if (params.companyId) {
      url.searchParams.append("companyId", `${params.companyId}`);
    }
    if (params.playbookId) {
      url.searchParams.append("playbookId", `${params.playbookId}`);
    }
    if (params.pageId) {
      url.searchParams.append("pageId", `${params.pageId}`);
    }
    if (params.folderId) {
      url.searchParams.append("folderId", `${params.folderId}`);
    }
    if (params.languageId) {
      url.searchParams.append("languageId", `${params.languageId}`);
    }
    if (params.pageTemplateId) {
      url.searchParams.append("pageTemplateId", `${params.pageTemplateId}`);
    }
    if (params.pageFrom) {
      url.searchParams.append("pageFrom", `${params.pageFrom}`);
    }

    if (window.navigator["clipboard"]) {
      window.navigator["clipboard"].writeText(url.toString());
    }
    this.messageService.showSuccessMessage(
      "Resource Shareable Link successfully copied to your clipboard."
    );
  }

  downloadFile(e: any, res: any) {
    e.preventDefault();

    this.commonHttpService
      .get<IResourceFull>({
        uri: `/api/Assets/Resource/${res.assetId}`,
      })
      .subscribe((resource) => {
        this.downloadAssets(resource.filePath);
      });
  }

  downloadAssets(downloadAssetUrl) {
    const anchor = document.createElement("a");
    anchor.download = downloadAssetUrl;
    anchor.target = "_blank";
    anchor.href = downloadAssetUrl;
    anchor.click();
    anchor.remove();
  }
}
